import { render } from "./ReviewTaskCard.vue?vue&type=template&id=ae88a19a&scoped=true"
import script from "./ReviewTaskCard.vue?vue&type=script&lang=js"
export * from "./ReviewTaskCard.vue?vue&type=script&lang=js"

import "./ReviewTaskCard.vue?vue&type=style&index=0&id=ae88a19a&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ae88a19a"]])

export default __exports__